import tracking from "frontend/tracking";
import consts from "shared/consts";
import { Board } from "shared/datamodel/schemas";

export const navigateToBoard = (board: Pick<Board, "documentId" | "name">) => {
  tracking.trackEvent(consts.TRACKING_CATEGORY.CANVAS_ACTION, "navigate_to_canvas", "canvas_name", board.name);
  window.location.assign(`${process.env.NEXT_BRANCH_PATH}/d/${board.documentId}`);
};
